
import WebClientConstants from '../constants/WebClientConstants';
import assign from 'object-assign';
import AppDispatcher from '../flux/AppDispatcher';
import NodeEvents from 'events';
var EventEmitter = NodeEvents.EventEmitter;

var CHANGE_EVENT = 'webclient.change';
var _exportSceneToGLB: () => any;
var _exportSceneToOBJ: () => any;

var WebClientStore: IWebClientStore = assign({}, EventEmitter.prototype, {
    exportSceneToOBJ() {
        return _exportSceneToOBJ();
    },

    exportSceneToGLB() {
        return _exportSceneToGLB();
    },   

    canExportScene() {
        if ((typeof _exportSceneToGLB == 'function' || _exportSceneToGLB != null) &&
            (typeof _exportSceneToOBJ == 'function' || _exportSceneToOBJ != null))
            return true;
        else
            return false;
    },

    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },

    addChangeListener: function (callback: any) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function (callback: any) {
        this.removeListener(CHANGE_EVENT, callback);
    }
});

AppDispatcher.get(WebClientConstants.DISPATCHER).register(function (payload: any) {
    switch (payload.actionType) {
        case WebClientConstants.SET_EXPORT_GLB:
            _exportSceneToGLB = payload.getExportFunc;
            break;
        case WebClientConstants.SET_EXPORT_OBJ:
            _exportSceneToOBJ = payload.getExportFunc;
            break;
        default:
            _exportSceneToGLB = null;
            _exportSceneToOBJ = null;
            return true;
    }  

    WebClientStore.emitChange();
    return true;
});

export default WebClientStore;